import theme from '@adsk/alloy-react-theme';

export const dropdownStyle = {
  paddingTop: '16px',
};

export const dropdownLabelStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  paddingBottom: '8px',
};

export const dropdownLabelNameStyle = {
  ...theme.typography.labelSmall,
  color: theme.colors.charcoal700,
};

export const dropdownLabelSheetStyle = {
  ...theme.typography.labelSmall,
  color: theme.colors.charcoal500,
};

export const dropdownValueStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
};

export const dropdownOptionStyle = (disabled) => ({
  width: '100%',
  color: disabled ? theme.colors.charcoal600 : theme.colors.black,
});

export const iconStyle = {
  color: theme.colors.yellowOrange500,
  height: '13.55px',
  marginRight: '4px',
  position: 'relative',
  top: '2px',
  width: '14.28px',
};

export const optionNameStyle = (disabled) => ({
  ...theme.typography.bodyMedium,
  color: disabled ? theme.colors.charcoal500 : theme.colors.charcoal900,
});

export const availableTextStyle = (disabled) => ({
  ...theme.typography.bodyMedium,
  color: disabled ? theme.colors.charcoal500 : theme.colors.charcoal700,
});

export const sheetCountErrorStyle = {
  ...theme.typography.bodySmall,
  color: theme.colors.charcoal900,
};
